<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
    <mat-panel-title>
        Notice of Obligation
    </mat-panel-title>
    </mat-expansion-panel-header>
  
        <div class="p-4">
            <form [formGroup]="noticeOfObligations">

            <div class="row">
                <h5 class="col-md-8 labelText"> Notice of Obligation </h5>      
                <div class="col-md-4 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                    <button class="clear-data-button" (click)="clearData()">
                        <i class="fa fa-repeat"></i> Clear Data
                     </button>
                </div>
            </div>
            
            <div class="row">
                <!-- Contact Person -->
                <div class="form-group col-md-4">
                    <!-- <label class="label-cls required">Authorized Person </label>
                    <select class="im-input" 
                    name="authorisePerson"
                    formControlName="authorisePerson"
                    (change)="onChangeContactPerson($event.target.value)">
                <option *ngFor="let item of listContact" [value]="item.id">
                    {{item.empName}}
                </option> 
                    </select> -->

                    <mat-form-field>
                        <label class="label-cls required">Authorized Person </label>
                        <mat-select name="authorisePerson"
                                    formControlName="authorisePerson"
                                    (selectionChange)="onChangeContactPerson($event.value)">
                                    <mat-option *ngFor="let item of listContact" [value]="item.id">
                                      {{item.empName}}
                                    </mat-option> 
                                  </mat-select>
                              </mat-form-field> 
                </div>
            </div>
            <div class="row mt-2">

                <span class=" col-md-12">

                    <mat-checkbox class="label-cls" name="cb"
                    formControlName="cb" (change)="checkCheckBoxvalue($event)"></mat-checkbox>

                        I declare under penalty of perjury that I have read and reviewed 
                        this application and that to the best of my knowledge, the information 
                        contained therein is true and accurate.I
                          understand that to knowingly 
                        furnish materially false information in the preparation of this form and
                         any supplement thereto or to aid, abet, or counsel another to do so is a 
                         federal offense punishable by fines, imprisonment, or both (18 U.S.C. 2, 1001,1546,1621)  
                        
                </span>
     
                
                     
                   
  
    </div>

            <div class="row mt-2">
                <!-- First Name -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">First Name (Given)</label>
                    <input class="im-input"
                            name="firstName"
                            formControlName="firstName"
                            type="text"
                            placeholder="Enter" [readonly]="enableReadOnlyMode" />
                            <span class="invalid-message"                    
                            *ngIf="(noticeOfObligations.get('firstName').touched && noticeOfObligations.get('firstName').invalid) || (noticeOfObligations.get('firstName').touched && noticeOfObligations.get('firstName').errors?.required)">
                            {{ getGlobalErrorMessages("INVALID_NAME") }}
                        </span>
                </div>
                <!-- Middle Name -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls ">Middle Name</label>
                    <input class="im-input"
                    name="middleName"
                    formControlName="middleName"
                            type="text"
                            placeholder="Enter" [readonly]="enableReadOnlyMode" />
                            <span class="invalid-message"
                            *ngIf="(noticeOfObligations.get('middleName').touched && noticeOfObligations.get('middleName').invalid) || (noticeOfObligations.get('middleName').touched && noticeOfObligations.get('middleName').errors?.required)">
                            {{ getGlobalErrorMessages("INVALID_NAME") }}
                        </span>
                </div>
                <!-- Last Name (Family Name) -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">Last Name (Family Name)</label>
                    <input class="im-input"
                    name="lastName"
                    formControlName="lastName"
                            type="text"
                            placeholder="Enter" [readonly]="enableReadOnlyMode" />
                            <span class="invalid-message"
                            *ngIf="(noticeOfObligations.get('lastName').touched && noticeOfObligations.get('lastName').invalid) || (noticeOfObligations.get('lastName').touched && noticeOfObligations.get('lastName').errors?.required)">
                            {{ getGlobalErrorMessages("INVALID_NAME") }}
                        </span>
                </div>
            </div> 
      
            <div  class="row mt-2">
                <!-- Address 1 -->
                <div class="form-group col-md-6">
                    <label class="control-lbl  label-cls required">Hiring or Designated official Title</label>
                    <input class="im-input"
                            type="text"                   
                            name="designatedTitle"
                            formControlName="designatedTitle"                  
                            placeholder="Enter" [readonly]="enableReadOnlyMode" />
                            <span class="invalid-message"
                            *ngIf="(noticeOfObligations.get('designatedTitle').touched && noticeOfObligations.get('designatedTitle').invalid) || (noticeOfObligations.get('designatedTitle').touched && noticeOfObligations.get('designatedTitle').errors?.required)">
                            {{ getGlobalErrorMessages("DESIGNATED_TITLE") }}
                        </span>
                </div>
            </div>

        </form>
    
      
    </div>
    
<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>